import { TableCell, TableRow, Typography } from "@mui/material";
import { format, parseISO } from "date-fns";

import HNSColors from "../../../../../ui library/HNSColors";
import { convertKeysToCamelCaseDeep } from "../../helper/functions";

const formatDate = (value) => {
  if (!value) {
    return "";
  }

  try {
    return format(parseISO(value), "MM/dd/yyyy");
  } catch {
    return value;
  }
};

const getBooleanValue = (value) => {
  if (value === true || value === false) {
    return value;
  }
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  return null;
};

const formatStatus = (row) => {
  const normalized = convertKeysToCamelCaseDeep(JSON.parse(JSON.stringify(row ?? {})));
  const explicitStatus =
    normalized?.statusLabel ??
    normalized?.displayStatus ??
    (typeof normalized?.status === "string" ? normalized.status : "");

  if (explicitStatus) {
    return explicitStatus;
  }

  const columnName = normalized?.columnName ?? normalized?.fieldName ?? normalized?.field ?? "";
  const value =
    getBooleanValue(normalized?.newValue) ??
    getBooleanValue(normalized?.value) ??
    getBooleanValue(normalized?.status);

  if (columnName === "in_network") {
    return value === null ? "Network Status" : value ? "In Network" : "Out of Network";
  }
  if (columnName === "receiving_clients") {
    return value === null
      ? "Receiving Clients"
      : `Receiving Clients: ${value ? "Yes" : "No"}`;
  }
  if (columnName === "accepts_funding") {
    return value === null ? "Accepts Funding" : `Accepts Funding: ${value ? "Yes" : "No"}`;
  }

  return columnName ? columnName.replaceAll("_", " ") : "";
};

const getUpdatedBy = (row) => {
  const normalized = convertKeysToCamelCaseDeep(JSON.parse(JSON.stringify(row ?? {})));
  return (
    normalized?.updatedBy?.name ??
    normalized?.updatedBy?.username ??
    normalized?.updatedByName ??
    normalized?.createdBy?.name ??
    normalized?.createdBy?.username ??
    ""
  );
};

export default function NetworkSettingsHistoryTableRow({ row }) {
  const normalized = convertKeysToCamelCaseDeep(JSON.parse(JSON.stringify(row ?? {})));
  const startDate = normalized?.startDate ?? normalized?.createdAt ?? "";
  const endDate = normalized?.endDate ?? "";

  return (
    <TableRow
      hover
      sx={{
        "&:hover": {
          backgroundColor: HNSColors.tertiary[950],
        },
      }}
    >
      <TableCell
        sx={{
          color: HNSColors.neutrals[100],
          borderBottomColor: HNSColors.neutrals[850],
          paddingTop: 1.5,
          paddingBottom: 1.5,
          paddingLeft: 0,
          paddingRight: 2,
          verticalAlign: "top",
        }}
      >
        <Typography className="text-sm">{formatStatus(normalized)}</Typography>
      </TableCell>
      <TableCell
        sx={{
          color: HNSColors.neutrals[100],
          borderBottomColor: HNSColors.neutrals[850],
          paddingTop: 1.5,
          paddingBottom: 1.5,
          paddingLeft: 0,
          paddingRight: 2,
          verticalAlign: "top",
        }}
      >
        <Typography className="text-sm">{formatDate(startDate)}</Typography>
      </TableCell>
      <TableCell
        sx={{
          color: HNSColors.neutrals[100],
          borderBottomColor: HNSColors.neutrals[850],
          paddingTop: 1.5,
          paddingBottom: 1.5,
          paddingLeft: 0,
          paddingRight: 2,
          verticalAlign: "top",
        }}
      >
        <Typography className="text-sm">{formatDate(endDate)}</Typography>
      </TableCell>
      <TableCell
        sx={{
          color: HNSColors.neutrals[100],
          borderBottomColor: HNSColors.neutrals[850],
          paddingTop: 1.5,
          paddingBottom: 1.5,
          paddingLeft: 0,
          paddingRight: 0,
          verticalAlign: "top",
        }}
      >
        <Typography className="text-sm">{getUpdatedBy(normalized)}</Typography>
      </TableCell>
    </TableRow>
  );
}
